import { RadioOption } from "@/context/data.types";
import { DropdownOption, MultiInputOption, SingleInputOption } from "@int-traderjoes/ui-components-library";

export const PackagingExamples: any = {
  "1001": { 
    variants: [{
      variantId: 1,
      variantName: "Single Pack",
      packagingComponents: [{
        id: "packaging-1",
        packagingDescription: "Cookie Ginger single pack",
        packagingComponentName: "Cookie Tray",
        level: "Primary (Food Contact)",
        foodContact: true,
        specificationCharacteristics: "Food-grade plastic tray",
        weightOfComponentGrams: 15,
        recycledContentPercent: 25,
        containsBPA: false,
        weightOfRecycledGrams: 3.75,
        packagingSupplier: "Wonderful Pi... Supplier",
        countryOfOrigin: "USA",
        dimensions: "12 oz package",
        material: "Polyethylene",
      }],
      recyclingIconsData: [{ text: "PAP 22", supportingText: "Recyclable", useOnPack: "PDP" }],
      otherLabellingInfoData: {
        productDescriptor: "Cookie Ginger", 
        otherProductMarketingInfo: "Crispy ginger cookies",
        foodSafetyOrHaccpPlanDesignation: "FDA",
        brandType: "Yes",
        otherBrandRegulatorySupplyDetails: "-" 
      },
      weightUnitsSpecificationData: {
        quantities: "1 x 12 oz",
        declaredQuantityType: "Fixed",
        declaredQuantityPrintingBy: "Pre-printed on pack",
        netDeclaredWeightVolume: "12 oz",
        locationOnPack: "PDP" ,
        drainedWeight: "12 oz"
      },
      iconsAndClaimsData: { brandLogo: null ,useOnPack: "PDP"},
      regionSpecificIconsData: [{
        onPackIcons: "icon_usa",
        supportingTextForDeclaration: "Recyclable where facilities exist",
        useOnPack: "PDP" 
      }],
      nutritionDietaryIconsData: {
        icon: "Vegan",
        supportingTextForDeclaration: "",
        useOnPack: "Back of Pack" 
      },
      claimsDisclaimerNotPetFoodsData: {
        format: "—",
        text: "—",
        useOnPack: "Back of Pack" 
      },
      safetyProcessingEnvironmentalData: [{
        format: "—",
        text: "—",
        useOnPack: "—" ,
        statements: []
      }],
      storageHandlingDistributionData: [{
        format: "Store cool & dry",
        text: "Use within 3 days after opening",
        isKeepFrozenRequired: false ,
        statements: []
      }],
      codingStatementsData: {
        statement: "Best Before",
        useOnPack: "Back of Pack" 
      },
      kosherSymbolData: [{
        onPackIcon: "K - Kosher",
        supportingTextForDeclaration: "Recyclable where facilities exist",
        useOnPack: "Back of Pack" 
      }],
      kosherDesignation: [{
        onPackIcon: "K - Kosher",
        supportingTextForDeclaration: "Recyclable where facilities exist",
        useOnPack: "Back of Pack" 
      }]
    }],
  },
  
  "1002": { 
    variants: [{
      variantId: 1,
      variantName: "Single Pack",
      packagingComponents: [{
        id: "packaging-1",
        packagingDescription: "Cookie Ginger single pack",
        packagingComponentName: "Cookie Tray",
        level: "Primary (Food Contact)",
        foodContact: true,
        specificationCharacteristics: "Food-grade plastic tray",
        weightOfComponentGrams: 15,
        recycledContentPercent: 25,
        containsBPA: false,
        weightOfRecycledGrams: 3.75,
        packagingSupplier: "Wonderful Pi... Supplier",
        countryOfOrigin: "USA",
        dimensions: "12 oz package",
        material: "Polyethylene",
      }],
      recyclingIconsData: [{ text: "PAP 22", supportingText: "Recyclable", useOnPack: "PDP" }],
      otherLabellingInfoData: {
        productDescriptor: "Cookie Ginger", 
        otherProductMarketingInfo: "Crispy ginger cookies",
        foodSafetyOrHaccpPlanDesignation: "FDA",
        brandType: "Yes",
        otherBrandRegulatorySupplyDetails: "-" 
      },
      weightUnitsSpecificationData: {
        quantities: "1 x 12 oz",
        declaredQuantityType: "Fixed",
        declaredQuantityPrintingBy: "Pre-printed on pack",
        netDeclaredWeightVolume: "12 oz",
        locationOnPack: "PDP" ,
        drainedWeight: "12 oz"
      },
      iconsAndClaimsData: { brandLogo: null ,useOnPack: "PDP"},
      regionSpecificIconsData: [{
        onPackIcons: "icon_usa",
        supportingTextForDeclaration: "Recyclable where facilities exist",
        useOnPack: "PDP" 
      }],
      nutritionDietaryIconsData: {
        icon: "Vegan",
        supportingTextForDeclaration: "",
        useOnPack: "Back of Pack" 
      },
      claimsDisclaimerNotPetFoodsData: {
        format: "—",
        text: "—",
        useOnPack: "Back of Pack" 
      },
      safetyProcessingEnvironmentalData: [{
        format: "—",
        text: "—",
        useOnPack: "—" ,
        statements: []
      }],
      storageHandlingDistributionData: [{
        format: "Store cool & dry",
        text: "Use within 3 days after opening",
        isKeepFrozenRequired: false ,
        statements: []
      }],
      codingStatementsData: {
        statement: "Best Before",
        useOnPack: "Back of Pack" 
      },
      kosherSymbolData: [{
        onPackIcon: "K - Kosher",
        supportingTextForDeclaration: "Recyclable where facilities exist",
        useOnPack: "Back of Pack" 
      }],
      kosherDesignation: [{
        onPackIcon: "K - Kosher",
        supportingTextForDeclaration: "Recyclable where facilities exist",
        useOnPack: "Back of Pack" 
      }]
    }],
  },

  // Generic fallback for any other product IDs
  "default": {
    variants: [{
      variantId: 1,
      variantName: "Default Variant",
      packagingComponents: [{
        id: "packaging-1",
        packagingDescription: "Default packaging data",
        packagingComponentName: "Generic Container",
        level: "Primary (Food Contact)",
        foodContact: true,
        specificationCharacteristics: "Standard packaging",
        weightOfComponentGrams: 10,
        recycledContentPercent: 20,
        containsBPA: false,
        weightOfRecycledGrams: 2,
        packagingSupplier: "Generic Supplier",
        countryOfOrigin: "USA",
        dimensions: "Standard size",
        material: "Generic Material"
      }],
    }]
  }
};

export const claimsDisclaimerStatementsOptions: MultiInputOption[] = [
  {
    id: "1",
    label:
      "Maximum Alcohol Content {} % v/w. Sale of this product to persons under the legal age for purchasing alcoholic beverages is unlawful. Pregnant women should not consume the confectionery, and persons consuming the confectionery should not operate equipment.",
  },
  {
    id: "2",
    label: "Minimally Processed",
  },
  {
    id: "3",
    label: "Minimally Processed, No Artificial Ingredients",
  },
  {
    id: "4",
    label: "No Artificial Ingredients",
  },
  {
    id: "5",
    label:
      "No significant difference has been shown between milk derived from cows treated with rBST and those not treated with rBST.",
  },
  {
    id: "6",
    label: "Aged {} Years",
  },
  {
    id: "7",
    label: "All Vegetarian Feed",
  },
  {
    id: "8",
    label: "Antibiotic Free",
  },
  {
    id: "9",
    label: "Boneless White Meat Chicken",
  },
  {
    id: "10",
    label: "Chicken Raised On An All Vegetarian Diet and Without The Use of Antibiotics",
  },
  {
    id: "11",
    label: "Chicken Raised Without Antibiotics",
  },
  {
    id: "12",
    label: "Color will darken over time. This does not alter the potency of the product",
  },
  {
    id: "13",
    label: "Contains Sulfites",
  },
  {
    id: "14",
    label: "Contains up to {} % of a solution",
  },
  {
    id: "15",
    label: "Contains up to {} % solution of: {}",
  },
  {
    id: "16",
    label: "Controlled Release",
  },
  {
    id: "17",
    label: "Decaffeinated",
  },
  {
    id: "18",
    label: "Dietary Supplement For Kids of All Ages",
  },
  {
    id: "19",
    label: "Enhanced with an {} % Salt Solution",
  },
  {
    id: "20",
    label: "Fair Trade",
  },
  {
    id: "21",
    label: "Farm Raised",
  },
  {
    id: "22",
    label: "Federal Regulations Prohibit The Use Of Added Hormones In Poultry",
  },
  {
    id: "23",
    label: "From Concentrate",
  },
  {
    id: "24",
    label: "Fully Cooked",
  },
  {
    id: "25",
    label: "Gluten Free",
  },
  {
    id: "26",
    label: "Grade A",
  },
  {
    id: "27",
    label: "Grass Fed",
  },
  {
    id: "28",
    label: "Hand Made",
  },
  {
    id: "29",
    label: "Humanely raised on sustainable U.S. Ranches",
  },
  {
    id: "30",
    label: "In Extra Virgin Olive Oil",
  },
  {
    id: "31",
    label: "Made With Mostly Dark Chicken Meat",
  },
  {
    id: "32",
    label: "Made With Real {}",
  },
  {
    id: "33",
    label: "Maximum Alcohol Content {} % v/w",
  },
  {
    id: "34",
    label: "Microwave Ready",
  },
  {
    id: "35",
    label: "Microwaveable",
  },
  {
    id: "36",
    label: "Natural Flavor",
  },
  {
    id: "37",
    label: "Never Fed Animal By-Products",
  },
  {
    id: "38",
    label: "Never given antibiotics or added hormones - ever",
  },
  {
    id: "39",
    label: "No Added Hormones",
  },
  {
    id: "40",
    label: "No Antibiotics Ever",
  },
  {
    id: "41",
    label: "No nitrates or nitrites added",
  },
  {
    id: "42",
    label: "No nitrates or nitrites added, Except for those naturally occurring in {}",
  },
  {
    id: "43",
    label: "No Preservatives",
  },
  {
    id: "44",
    label: "Non-Dairy",
  },
  {
    id: "45",
    label: "Not For Individual Retail Sale",
  },
  {
    id: "46",
    label: "Not From Concentrate",
  },
  {
    id: "47",
    label: "Oil Separation Occurs. Stir & Refrigerate After Opening.",
  },
  {
    id: "48",
    label: "Our Cows Just Say Noooo",
  },
  {
    id: "49",
    label: "Our Farmers Guarantee",
  },
  {
    id: "50",
    label: "Prewashed",
  },
  {
    id: "51",
    label: "Raised Without Antibiotics",
  },
  {
    id: "52",
    label: "Ready to Eat",
  },
  {
    id: "53",
    label: "Ready to Heat",
  },
  {
    id: "54",
    label: "Ready to Use",
  },
  {
    id: "55",
    label: "Serving Suggestion",
  },
  {
    id: "56",
    label: "Shade Grown",
  },
  {
    id: "57",
    label: "Some settling of contents may have occurred during handling and shipping",
  },
  {
    id: "58",
    label: "Sustainably Raised",
  },
  {
    id: "59",
    label: "Sweetened",
  },
  {
    id: "60",
    label:
      "The use of KEURIG® and K-CUP® on this packaging is for identification purposes only and does not imply or suggest that Keurig Green Mountain, Inc. is affiliated with or endorses Trader Joe’s or its products.",
  },
  {
    id: "61",
    label:
      "The wheat in the {} has been processed to allow the food to meet FDA requirements for a gluten-free claim",
  },
  {
    id: "62",
    label: "This product is sold by weight not volume",
  },
  {
    id: "63",
    label: "This product may settle during shipping",
  },
  {
    id: "64",
    label:
      "Trader Joe's cutting-edge Once Daily Controlled Release {} is formulated to release steadily, allowing just one dose daily",
  },
  {
    id: "65",
    label: "Triple Distilled",
  },
  {
    id: "66",
    label: "Uncured",
  },
  {
    id: "67",
    label: "Under The Tongue",
  },
  {
    id: "68",
    label: "Unsulfured",
  },
  {
    id: "69",
    label: "Unsweetened",
  },
  {
    id: "70",
    label: "Vegetarian",
  },
  {
    id: "71",
    label: "Washed & Cleaned",
  },
  {
    id: "72",
    label: "Washed and Ready to Use",
  },
  {
    id: "73",
    label: "{} Flavor with other natural flavors",
  },
  {
    id: "74",
    label: "{} % Acidity",
  },
];

export const countryOfOriginStatementsSingleOptions: SingleInputOption[] = [
  { id: "1", label: "Born in" },
  { id: "2", label: "Born, Raised and Harvested in" },
  { id: "3", label: "Bottled at source: {}" },
  { id: "4", label: "Bottled at the {} source, in {}" },
  { id: "5", label: "Caught in" },
  { id: "6", label: "Cultivated in" },
  { id: "7", label: "Cured and Packed in" },
  { id: "8", label: "Farmed in" },
  { id: "9", label: "Grown and Packed in" },
  { id: "10", label: "Grown in" },
  { id: "11", label: "Harvested in" },
  { id: "12", label: "Hatched, Raised and Harvested in" },
  { id: "13", label: "Hatched, Raised, Harvested & Processed in" },
  { id: "14", label: "Made in" },
  { id: "15", label: "Manufactured in" },
  { id: "16", label: "Packed in" },
  { id: "17", label: "Processed in" },
  { id: "18", label: "Produce Of" },
  { id: "19", label: "Produced in" },
  { id: "20", label: "Product of" },
  { id: "21", label: "Raised and Harvested in" },
  { id: "22", label: "Raised in" },
  { id: "23", label: "Smoked in" },
  { id: "24", label: "Sourced from" },
  { id: "25", label: "Wild Caught" },
  { id: "26", label: "Wild caught in" },
];

export const safetyProcessingEnvironmentalOptions: MultiInputOption[] = [
  {
    id: "1",
    label:
      "Maximum Alcohol Content {} % v/w. Sale of this product to persons under the legal age for purchasing alcoholic beverages is unlawful. Pregnant women should not consume the confectionery, and persons consuming the confectionery should not operate equipment.",
  },
  {
    id: "2",
    label: "Minimally Processed",
  },
  {
    id: "3",
    label: "Minimally Processed, No Artificial Ingredients",
  },
  {
    id: "4",
    label: "No Artificial Ingredients",
  },
  {
    id: "5",
    label:
      "No significant difference has been shown between milk derived from cows treated with rBST and those not treated with rBST.",
  },
  {
    id: "6",
    label: "Aged {} Years",
  },
  {
    id: "7",
    label: "All Vegetarian Feed",
  },
  {
    id: "8",
    label: "Antibiotic Free",
  },
  {
    id: "9",
    label: "Boneless White Meat Chicken",
  },
  {
    id: "10",
    label: "Chicken Raised On An All Vegetarian Diet and Without The Use of Antibiotics",
  },
  {
    id: "11",
    label: "Chicken Raised Without Antibiotics",
  },
  {
    id: "12",
    label: "Color will darken over time. This does not alter the potency of the product.",
  },
  {
    id: "13",
    label: "Contains Sulfites",
  },
  {
    id: "14",
    label: "Contains up to {} % of a solution",
  },
  {
    id: "15",
    label: "Contains up to {} % solution of: {}",
  },
  {
    id: "16",
    label: "Controlled Release",
  },
  {
    id: "17",
    label: "Decaffeinated",
  },
  {
    id: "18",
    label: "Dietary Supplement For Kids of All Ages",
  },
  {
    id: "19",
    label: "Enhanced with an {} % Salt Solution",
  },
  {
    id: "20",
    label: "Fair Trade",
  },
  {
    id: "21",
    label: "Farm Raised",
  },
  {
    id: "22",
    label: "Federal Regulations Prohibit The Use Of Added Hormones In Poultry",
  },
  {
    id: "23",
    label: "From Concentrate",
  },
  {
    id: "24",
    label: "Fully Cooked",
  },
  {
    id: "25",
    label: "Gluten Free",
  },
  {
    id: "26",
    label: "Grade A",
  },
  {
    id: "27",
    label: "Grass Fed",
  },
  {
    id: "28",
    label: "Hand Made",
  },
  {
    id: "29",
    label: "Humanely raised on sustainable U.S. Ranches",
  },
  {
    id: "30",
    label: "In Extra Virgin Olive Oil",
  },
  {
    id: "31",
    label: "Made With Mostly Dark Chicken Meat",
  },
  {
    id: "32",
    label: "Made With Real {}",
  },
  {
    id: "33",
    label: "Maximum Alcohol Content {} % v/w",
  },
  {
    id: "34",
    label: "Microwave Ready",
  },
  {
    id: "35",
    label: "Microwaveable",
  },
  {
    id: "36",
    label: "Natural Flavor",
  },
  {
    id: "37",
    label: "Never Fed Animal By-Products",
  },
  {
    id: "38",
    label: "Never given antibiotics or added hormones - ever",
  },
  {
    id: "39",
    label: "No Added Hormones",
  },
  {
    id: "40",
    label: "No Antibiotics Ever",
  },
  {
    id: "41",
    label: "No nitrates or nitrites added",
  },
  {
    id: "42",
    label: "No nitrates or nitrites added, Except for those naturally occurring in {}",
  },
  {
    id: "43",
    label: "No Preservatives",
  },
  {
    id: "44",
    label: "Non-Dairy",
  },
  {
    id: "45",
    label: "Not For Individual Retail Sale",
  },
  {
    id: "46",
    label: "Not From Concentrate",
  },
  {
    id: "47",
    label: "Oil Separation Occurs. Stir & Refrigerate After Opening.",
  },
  {
    id: "48",
    label: "Our Cows Just Say Noooo",
  },
  {
    id: "49",
    label: "Our Farmers Guarantee",
  },
  {
    id: "50",
    label: "Prewashed",
  },
  {
    id: "51",
    label: "Raised Without Antibiotics",
  },
  {
    id: "52",
    label: "Ready to Eat",
  },
  {
    id: "53",
    label: "Ready to Heat",
  },
  {
    id: "54",
    label: "Ready to Use",
  },
  {
    id: "55",
    label: "Serving Suggestion",
  },
  {
    id: "56",
    label: "Shade Grown",
  },
  {
    id: "57",
    label: "Some settling of contents may have occurred during handling and shipping",
  },
  {
    id: "58",
    label: "Sustainably Raised",
  },
  {
    id: "59",
    label: "Sweetened",
  },
  {
    id: "60",
    label:
      "The use of KEURIG® and K-CUP® on this packaging is for identification purposes only and does not imply or suggest that Keurig Green Mountain, Inc. is affiliated with or endorses Trader Joe’s or its products.",
  },
  {
    id: "61",
    label:
      "The wheat in the {} has been processed to allow the food to meet FDA requirements for a gluten-free claim",
  },
  {
    id: "62",
    label: "This product is sold by weight not volume",
  },
  {
    id: "63",
    label: "This product may settle during shipping",
  },
  {
    id: "64",
    label:
      "Trader Joe's cutting-edge Once Daily Controlled Release {} is formulated to release steadily, allowing just one dose daily",
  },
  {
    id: "65",
    label: "Triple Distilled",
  },
  {
    id: "66",
    label: "Uncured",
  },
  {
    id: "67",
    label: "Under The Tongue",
  },
  {
    id: "68",
    label: "Unsulfured",
  },
  {
    id: "69",
    label: "Unsweetened",
  },
  {
    id: "70",
    label: "Vegetarian",
  },
  {
    id: "71",
    label: "Washed & Cleaned",
  },
  {
    id: "72",
    label: "Washed and Ready to Use",
  },
  {
    id: "73",
    label: "{} Flavor with other natural flavors",
  },
  {
    id: "74",
    label: "{} % Acidity",
  },
];

export const orgcanicProductIconsOptions: DropdownOption[] = [
  {
    value: "1",
    label: "Claim - Made with Organic",
  },
  {
    value: "2",
    label: "Claim – Organic with the USDA Organic Logo",
  },
  {
    value: "3",
    label: "Certified Organic by Americert International",
  },
  {
    value: "4",
    label: "Certified Organic by Bioagricert SRL",
  },
  {
    value: "5",
    label: "Certified Organic by CCOF",
  },
  {
    value: "6",
    label: "Certified Organic by CCPB SRL",
  },
  {
    value: "7",
    label: "Certified Organic by Certimex S.C.",
  },
  {
    value: "8",
    label: "Certified Organic by Control Union",
  },
  {
    value: "9",
    label: "Certified Organic by Ecocert",
  },
  {
    value: "10",
    label: "Certified Organic by Ecocert Canada",
  },
  {
    value: "11",
    label: "Certified Organic by FVOPA",
  },
  {
    value: "12",
    label: "Certified Organic by GOA",
  },
  {
    value: "13",
    label: "Certified Organic by MOSA",
  },
  {
    value: "14",
    label: "Certified Organic by OCIA",
  },
  {
    value: "15",
    label: "Certified Organic by OCQV",
  },
  {
    value: "16",
    label: "Certified Organic by OEFFA",
  },
  {
    value: "17",
    label: "Certified Organic by OneCert",
  },
  {
    value: "18",
    label: "Certified Organic by OneCert International",
  },
  {
    value: "19",
    label: "Certified Organic by OnMark",
  },
  {
    value: "20",
    label: "Certified Organic by Oregon Tilth",
  },
  {
    value: "21",
    label: "Certified Organic by Organic Certifiers",
  },
  {
    value: "22",
    label: "Certified Organic by OTCO",
  },
  {
    value: "23",
    label: "Certified Organic by PCO",
  },
  {
    value: "24",
    label: "Certified Organic by Primus Auditing Ops",
  },
  {
    value: "25",
    label: "Certified Organic by Pro-Cert",
  },
  {
    value: "26",
    label: "Certified Organic by QCS",
  },
  {
    value: "27",
    label: "Certified Organic by Quality Assurance International",
  },
  {
    value: "28",
    label: "Certified Organic by SCS Global Services",
  },
  {
    value: "29",
    label: "Certified Organic by WFCFO",
  },
  {
    value: "30",
    label: "Certified Organic by WSDA",
  },
  {
    value: "31",
    label: "Certified Organic by YCOA",
  },
];

export const storageHandlingDistributionOptions: MultiInputOption[] = [
  {
    id: "1",
    label: "Store in a cool, dry place away from direct sunlight",
  },
  {
    id: "2",
    label: "Once opened, keep refrigerated and consume within 1 day",
  },
  {
    id: "3",
    label: "Once opened, keep refrigerated and consume within days",
  },
  {
    id: "4",
    label: "Once opened, store in an airtight container",
  },
  {
    id: "5",
    label: "Once opened, store in a separate container",
  },
  {
    id: "6",
    label: "Once thawed, do not refreeze",
  },
  {
    id: "7",
    label: "Once defrosted, do not refreeze",
  },
  {
    id: "8",
    label: "Store at room temperature",
  },
  {
    id: "9",
    label: "Keep tightly closed",
  },
  {
    id: "10",
    label: "Protect from freezing",
  },
  {
    id: "11",
    label: "Avoid excessive heat over °F degrees.",
  },
  {
    id: "12",
    label: "Protect from excessive heat and freezing",
  },
  {
    id: "13",
    label: "Store in a cool, dry place away from heat or open flame.",
  },
  {
    id: "14",
    label: "Do not expose to heat or store at temperatures above °F",
  },
  {
    id: "15",
    label: "Shake Well Before Using",
  },
  {
    id: "16",
    label: "Shake Well Before Using As Some Natural Settling May Occur",
  },
  {
    id: "17",
    label: "Perishable, Keep Refrigerated",
  },
  {
    id: "18",
    label: "Keep Refrigerated",
  },
  {
    id: "19",
    label: "Keep refrigerated at 38°F or below",
  },
  {
    id: "20",
    label: "Keep refrigerated below 40°F at all times",
  },
  {
    id: "21",
    label: "Keep Frozen",
  },
  {
    id: "22",
    label: "Keep Frozen Until Ready To Eat",
  },
  {
    id: "23",
    label: "Keep Refrigerated or Frozen",
  },
  {
    id: "24",
    label: "Previously Frozen",
  },
  {
    id: "25",
    label: "Not preserved",
  },
  {
    id: "26",
    label: "store in a cool, dry place",
  },
  {
    id: "27",
    label: "use within days after opening",
  },
  {
    id: "28",
    label: "Best if consumed within days after opening",
  },
  {
    id: "29",
    label: "Safe handling instructions (to appear on retail label)",
  },
  {
    id: "30",
    label: "Safe handling instructions (to appear on tech label)",
  },
  {
    id: "31",
    label: "Heat and Serve",
  },
  {
    id: "32",
    label: "Resealable container",
  },
  {
    id: "33",
    label: "store in a cool dry place, away from children",
  },
  {
    id: "34",
    label: "STORAGE: Store at room temperature; protect from direct sunlight, heat and moisture.",
  },
  {
    id: "35",
    label: "Refrigerate Unused Portion In a Separate Container",
  },
  {
    id: "36",
    label: "Perishable",
  },
  {
    id: "37",
    label: "SUGGESTED USE:",
  },
  {
    id: "38",
    label: "Do not expose to excessive heat or moisture",
  },
  {
    id: "39",
    label: "RECOMMENDATIONS:",
  },
  {
    id: "40",
    label: "Store at Room Temperature",
  },
  {
    id: "41",
    label: "Refrigerate After Opening",
  },
  {
    id: "42",
    label: "Once Open, Store Can in a Cool, Dry Place",
  },
  {
    id: "43",
    label: "Best When Consumed Within to Days After Opening",
  },
  {
    id: "44",
    label: "Imported By:",
  },
  {
    id: "45",
    label: "Bottling Site:",
  },
  {
    id: "46",
    label: "Vinted & Bottled by",
  },
  {
    id: "47",
    label: "Cellared And Bottled By",
  },
  {
    id: "48",
    label: "Brewed & Bottled By",
  },
  {
    id: "49",
    label: "Keep Refrigerated and Use Within Days After Opening",
  },
  {
    id: "50",
    label: "FOR EXTENDED SHELF LIFE, KEEP REFRIGERATED",
  },
];

export const claimsDisclaimerStatementsPetsOptions: MultiInputOption[] = [
  {
    id: "1",
    label: "*A standard 8 oz measuring cup of weighs oz.",
  },
  {
    id: "2",
    label: "*Not recognized as an essential nutrient by the AAFCO Food Nutrient Profiles",
  },
  {
    id: "3",
    label: "100% Nutritionally Complete",
  },
  {
    id: "4",
    label: "Antioxidant nutrients - to help support immune system",
  },
  {
    id: "5",
    label: "Assorted natural flavors",
  },
  {
    id: "6",
    label: "Calorie Content (Calculated) ME: kcal/kg: kcal/cup",
  },
  {
    id: "7",
    label: "Contains a source of live naturally occuring organisms",
  },
  {
    id: "8",
    label: "Feeding directions",
  },
  {
    id: "9",
    label: "Flaxseed",
  },
  {
    id: "10",
    label: "For Adult Cats",
  },
  {
    id: "11",
    label: "For Adult Dogs",
  },
  {
    id: "12",
    label: "For Kittens",
  },
  {
    id: "13",
    label: "For Lactating Females",
  },
  {
    id: "14",
    label: "FOR MAINTENANCE OF THE ADULT :",
  },
  {
    id: "15",
    label: "For Pregnant Females",
  },
  {
    id: "16",
    label: "For Puppies",
  },
  {
    id: "17",
    label: "FORMULATED FOR ALL LIFE STAGES",
  },
  {
    id: "18",
    label: "formulated for all your life stages",
  },
  {
    id: "19",
    label: "FORMULATED FOR DOGS, BIG & SMALL",
  },
  {
    id: "20",
    label: "Formulated for",
  },
  {
    id: "21",
    label: "Fortified with Vitamins For Your Pet",
  },
  {
    id: "22",
    label: "Fortified with for healthy immune system",
  },
  {
    id: "23",
    label: "Fortified with for healthy skin and coat",
  },
  {
    id: "24",
    label: "Fortified with to help support healthy heart and eyes",
  },
  {
    id: "25",
    label: "Fortified with to help support healthy skin and coat",
  },
  {
    id: "26",
    label: "Fruits and Vegetables",
  },
  {
    id: "27",
    label: "Healthy skin and coat formula",
  },
  {
    id: "28",
    label: "Introducing a New Cat Food",
  },
  {
    id: "29",
    label: "Introducing a New Dog Food",
  },
  {
    id: "30",
    label: "LOW FAT",
  },
  {
    id: "31",
    label: "Made with real",
  },
  {
    id: "32",
    label: "Multiple Protein Sources",
  },
  {
    id: "33",
    label: "Natural Ingredients",
  },
  {
    id: "34",
    label: "No Meat By-products",
  },
  {
    id: "35",
    label:
      "NUTRITIONAL ADEQUACY STATEMENT: Trader Joe's is formulated to meet the nutritional levels established by the AAFCO Food Nutrient Profiles for all life stages",
  },
  {
    id: "36",
    label: "NUTRITIONALLY COMPLETE",
  },
  {
    id: "37",
    label: "Nutritionally Complete With",
  },
  {
    id: "38",
    label: "Please provide fresh drinking water for your at all times",
  },
  {
    id: "39",
    label: "Probiotics",
  },
  {
    id: "40",
    label: "PROMOTES HAPPY DOG LIFE",
  },
  {
    id: "41",
    label: "Real Flavor",
  },
  {
    id: "42",
    label: "Scored For Easy Breaking",
  },
  {
    id: "43",
    label: "Store in a cool, dry place",
  },
  {
    id: "44",
    label: "SUGGESTED FEEDING PLAN",
  },
  {
    id: "45",
    label: "Vitamin & Antioxidant Nutrients",
  },
  {
    id: "46",
    label: "Whole grain goodness",
  },
  {
    id: "47",
    label: "Free",
  },
  {
    id: "48",
    label: "is the #1 ingredient",
  },
  {
    id: "49",
    label: "is the first ingredient",
  },
];

// Packaging Component Options
export const packagingComponentNameOptions: DropdownOption[] = [
  { label: "Lid", value: "Lid" },
  { label: "Cap", value: "Cap" },
  { label: "Body", value: "Body" },
  { label: "Wrapper", value: "Wrapper" },
];

export const materialOptions: DropdownOption[] = [
  { label: "Aluminum", value: "Aluminum" },
  { label: "Polyethylene", value: "Polyethylene" },
  { label: "Steel", value: "Steel" },
];

export const levelOptions: DropdownOption[] = [
  { label: "Primary (Food Contact)", value: "Primary (Food Contact)" },
  { label: "Secondary (Retail Pack - Non Food Contact)", value: "Secondary (Retail Pack - Non Food Contact)" },
  { label: "Tertiary (Master Packaging - Not Retail or Food Contact)", value: "Tertiary (Master Packaging - Not Retail or Food Contact)" },
];

export const yesNoOptions: DropdownOption[]  = [
  { label: "Yes", value: "yes" },
  { label: "No", value: "no" },
];

// Use on Pack Options
export const useOnPackOptions: DropdownOption[] = [
  { label: "Principle Display Panel (PDP)", value: "Principle Display Panel (PDP)" },
  { label: "Anywhere on Pack Other Than PDP", value: "Anywhere on Pack Other Than PDP" },
  { label: "PDP And Additional Panel", value: "PDP And Additional Panel" },
  { label: "Do Not Use on Pack", value: "Do Not Use on Pack" },
];

// Recycling Icon Options
export const recyclingIconOptions: DropdownOption[] = [
  { label: "22 - PAP - Paper", value: "22 - PAP - Paper" },
  { label: "1 - PET - Polyethylene Terephthalate", value: "1 - PET - Polyethylene Terephthalate" },
  { label: "2 - HDPE - High-Density Polyethylene", value: "2 - HDPE - High-Density Polyethylene" },
  { label: "3 - PVC - Polyvinyl Chloride", value: "3 - PVC - Polyvinyl Chloride" },
  { label: "4 - LDPE - Low-Density Polyethylene", value: "4 - LDPE - Low-Density Polyethylene" },
  { label: "5 - PP - Polypropylene", value: "5 - PP - Polypropylene" },
  { label: "6 - PS - Polystyrene", value: "6 - PS - Polystyrene" },
  { label: "7 - Other", value: "7 - Other" },
];

// Weight Unit Specification Options
export const declaredQuantityTypeOptions: DropdownOption[] = [
  { label: "Fixed", value: "Fixed" },
  { label: "Random", value: "Random" },
  { label: "Not Declared", value: "Not Declared" },
];

export const declaredQuantityPrintingByOptions: DropdownOption[] = [
  { label: "Pre-printed on pack", value: "Pre-printed on pack" },
  { label: "Printed by vendor", value: "Printed by vendor" },
];

export const locationOnPackOptions: DropdownOption[] = [
  { label: "Principal Display Panel (PDP)", value: "Principal Display Panel (PDP)" },
  { label: "Anywhere on Pack Other Than PDP", value: "Anywhere on Pack Other Than PDP" },
  { label: "PDP And Additional Panel", value: "PDP And Additional Panel" },
  { label: "Do Not Use on Pack", value: "Do Not Use on Pack" },

];

// Product Labelling Details Options
export const regulatoryGovernanceOptions: DropdownOption[] = [
  { label: "Trader Joe's FSVP", value: "Trader Joe's FSVP" },
  { label: "US", value: "US" },
];

// Claims and Disclaimer Statements Options
export const cosmeticWarningPhraseOptions: DropdownOption[] = [
  { label: "Choose Phrase", value: "" },
  { label: "For external use only", value: "For external use only" },
  { label: "Avoid contact with eyes", value: "Avoid contact with eyes" },
  { label: "Keep out of reach of children", value: "Keep out of reach of children" },
];

export const candleWarningPhraseOptions: DropdownOption[] = [
  { label: "Choose Phrase", value: "" },
  { label: "Never leave burning candle unattended", value: "Never leave burning candle unattended" },
  { label: "Keep away from flammable materials", value: "Keep away from flammable materials" },
  { label: "Keep away from children and pets", value: "Keep away from children and pets" },
  { label: "Trim wick to 1/4 inch before each use", value: "Trim wick to 1/4 inch before each use" },
  { label: "Do not burn for more than 4 hours at a time", value: "Do not burn for more than 4 hours at a time" },
];

// Country of Origin Options
export const countryOfOriginOptions: DropdownOption[] = [
  { label: "United States", value: "United States" },
  { label: "Canada", value: "Canada" },
  { label: "Mexico", value: "Mexico" },
  { label: "China", value: "China" },
  { label: "India", value: "India" },
  { label: "Brazil", value: "Brazil" },
  { label: "Italy", value: "Italy" },
  { label: "France", value: "France" },
  { label: "Germany", value: "Germany" },
  { label: "Spain", value: "Spain" },
  { label: "United Kingdom", value: "United Kingdom" },
  { label: "Japan", value: "Japan" },
  { label: "South Korea", value: "South Korea" },
  { label: "Australia", value: "Australia" },
  { label: "New Zealand", value: "New Zealand" },
];

// Reason for Country of Origin Labeling Options
export const reasonForCountryOfOriginOptions: DropdownOption[] = [
  { label: "US Customs Tariff", value: "US Customs Tariff" },
  { label: "Amendable to COOL", value: "Amendable to COOL" },
  { label: "Country of Origin NOT Required on Label", value: "Country of Origin NOT Required on Label" },
];

// Printer and Dieline Details Options
export const printerOptions: DropdownOption[] = [
  { label: "Printer 1", value: "Printer 1" },
  { label: "Printer 2", value: "Printer 2" },
  { label: "Printer 3", value: "Printer 3" },
];

export const dielineOptions: DropdownOption[] = [
  { label: "Dieline 1", value: "Dieline 1" },
  { label: "Dieline 2", value: "Dieline 2" },
  { label: "Dieline 3", value: "Dieline 3" },
];

// Bottle Redemption Information Options
export const bottleRedemptionOptions: DropdownOption[] = [
  { label: "Yes", value: "Yes" },
  { label: "No", value: "No" },
  { label: "Not Applicable", value: "Not Applicable" },
];

// Non-Copy Information Options
export const nonCopyOptions: DropdownOption[] = [
  { label: "Yes", value: "Yes" },
  { label: "No", value: "No" },
];

// Design Team options for Non-Copy Information
export const designTeamOptions: DropdownOption[] = [
  { label: "Boston TM", value: "Boston TM" },
  { label: "Monrovia TM", value: "Monrovia TM" },
];

// Cooking Instructions Options
export const cookingMethodOptions: DropdownOption[] = [
  { label: "Microwave", value: "Microwave" },
  { label: "Oven", value: "Oven" },
  { label: "Stovetop", value: "Stovetop" },
  { label: "Grill", value: "Grill" },
  { label: "Steam", value: "Steam" },
  { label: "Boil", value: "Boil" },
];

// Storage and Handling Options
export const storageTemperatureOptions: DropdownOption[] = [
  { label: "Room Temperature", value: "Room Temperature" },
  { label: "Refrigerated", value: "Refrigerated" },
  { label: "Frozen", value: "Frozen" },
  { label: "Cool and Dry", value: "Cool and Dry" },
];

// Safety Processing Environmental Options
export const safetyProcessingFormatOptions: DropdownOption[] = [
  { label: "Text", value: "Text" },
  { label: "Icon", value: "Icon" },
  { label: "Both", value: "Both" },
];

// Kosher Symbols and Designations Options
export const kosherSymbolOptions: DropdownOption[] = [
  { label: "OU - Orthodox Union", value: "OU - Orthodox Union" },
  { label: "K - Kosher", value: "K - Kosher" },
  { label: "Star-K", value: "Star-K" },
  { label: "OK - Organized Kashrut", value: "OK - Organized Kashrut" },
  { label: "CRC - Chicago Rabbinical Council", value: "CRC - Chicago Rabbinical Council" },
  { label: "Kof-K", value: "Kof-K" },
  { label: "OU-D - Dairy", value: "OU-D - Dairy" },
  { label: "OU-P - Pareve", value: "OU-P - Pareve" },
  { label: "OU-M - Meat", value: "OU-M - Meat" },
];

// Region Specific Icons Options
export const regionSpecificIconOptions: DropdownOption[] = [
  { label: "USA Flag", value: "USA Flag" },
  { label: "Canada Flag", value: "Canada Flag" },
  { label: "EU Flag", value: "EU Flag" },
  { label: "Recycling Symbol", value: "Recycling Symbol" },
  { label: "Organic Symbol", value: "Organic Symbol" },
];

// Product Specific Icons and Legends Options
export const productSpecificIconOptions: DropdownOption[] = [
  { label: "Gluten Free", value: "Gluten Free" },
  { label: "Dairy Free", value: "Dairy Free" },
  { label: "Nut Free", value: "Nut Free" },
  { label: "Soy Free", value: "Soy Free" },
  { label: "Vegan", value: "Vegan" },
  { label: "Vegetarian", value: "Vegetarian" },
  { label: "Non-GMO", value: "Non-GMO" },
  { label: "Organic", value: "Organic" },
];

// Icons and Claims Options
export const productClaimsOptions: DropdownOption[] = [
  { label: "Natural", value: "Natural" },
  { label: "Organic", value: "Organic" },
  { label: "Non-GMO", value: "Non-GMO" },
  { label: "Gluten Free", value: "Gluten Free" },
  { label: "Dairy Free", value: "Dairy Free" },
  { label: "Sugar Free", value: "Sugar Free" },
  { label: "Low Sodium", value: "Low Sodium" },
  { label: "High Protein", value: "High Protein" },
];

export const cautionStatementsOptions: DropdownOption[] = [
  { label: "Contains Nuts", value: "Contains Nuts" },
  { label: "Contains Dairy", value: "Contains Dairy" },
  { label: "Contains Soy", value: "Contains Soy" },
  { label: "Contains Gluten", value: "Contains Gluten" },
  { label: "May Contain Traces of Nuts", value: "May Contain Traces of Nuts" },
  { label: "Processed in a Facility that Processes Nuts", value: "Processed in a Facility that Processes Nuts" },
];

export const directionsForUseOptions: DropdownOption[] = [
  { label: "Shake Well Before Use", value: "Shake Well Before Use" },
  { label: "Refrigerate After Opening", value: "Refrigerate After Opening" },
  { label: "Use Within 7 Days of Opening", value: "Use Within 7 Days of Opening" },
  { label: "Best Before Date", value: "Best Before Date" },
  { label: "Expires On", value: "Expires On" },
];

// Storage Handling Distribution Options
export const storageHandlingFormatOptions: DropdownOption[] = [
  { label: "Text", value: "Text" },
  { label: "Icon", value: "Icon" },
  { label: "Both", value: "Both" },
];

// Pet Food Claims Disclaimer Options
export const petFoodClaimsOptions: DropdownOption[] = [
  { label: "Complete and Balanced", value: "Complete and Balanced" },
  { label: "For All Life Stages", value: "For All Life Stages" },
  { label: "Adult Maintenance", value: "Adult Maintenance" },
  { label: "Puppy/Kitten", value: "Puppy/Kitten" },
  { label: "Senior", value: "Senior" },
  { label: "Weight Management", value: "Weight Management" },
  { label: "Grain Free", value: "Grain Free" },
  { label: "Limited Ingredient", value: "Limited Ingredient" },
];

// Organic Products Options
export const organicProductIconOptions: DropdownOption[] = [
  { label: "USDA Organic", value: "USDA Organic" },
  { label: "Certified Organic", value: "Certified Organic" },
  { label: "Made with Organic Ingredients", value: "Made with Organic Ingredients" },
  { label: "100% Organic", value: "100% Organic" },
];

// Documents Options
export const documentTypeOptions: DropdownOption[] = [
  { label: "PDF", value: "PDF" },
  { label: "Word Document", value: "Word Document" },
  { label: "Excel Spreadsheet", value: "Excel Spreadsheet" },
  { label: "Image", value: "Image" },
  { label: "Other", value: "Other" },
];